import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { Crown } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from || "/trips";

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created. Welcome aboard.");
      navigate(from, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="register-page" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 pt-24 pb-12">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2 mb-3">
          <Crown className="w-5 h-5 text-[#C5A059]" />
          <span className="font-heading text-xl text-white">BLACK<span className="text-[#C5A059]">·</span>SAPPHIRE</span>
        </div>
        <div className="text-[9px] tracking-[0.4em] uppercase text-[#C5A059]/80 text-center mb-10">The Quiet Standard</div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059] text-center">Create Account</div>
        <h1 className="font-heading text-4xl sm:text-5xl text-white text-center mt-4">Join the lounge.</h1>
        <p className="text-[#A3A3A3] text-center mt-3 text-sm">Your private chauffeur, one tap away.</p>

        <form onSubmit={submit} className="mt-12 space-y-8">
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase text-white/50 block mb-2">Full Name</label>
            <input
              data-testid="register-name-input"
              required
              value={form.name}
              onChange={onChange("name")}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#C5A059] outline-none py-3 text-white text-lg"
              placeholder="Eleanor Voss"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase text-white/50 block mb-2">Email</label>
            <input
              data-testid="register-email-input"
              required
              type="email"
              value={form.email}
              onChange={onChange("email")}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#C5A059] outline-none py-3 text-white text-lg"
              placeholder="you@company.com"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase text-white/50 block mb-2">Phone (optional)</label>
            <input
              data-testid="register-phone-input"
              value={form.phone}
              onChange={onChange("phone")}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#C5A059] outline-none py-3 text-white text-lg"
              placeholder="+1 (212) 555-0100"
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.25em] uppercase text-white/50 block mb-2">Password</label>
            <input
              data-testid="register-password-input"
              required
              type="password"
              minLength={6}
              value={form.password}
              onChange={onChange("password")}
              className="w-full bg-transparent border-b border-white/20 focus:border-[#C5A059] outline-none py-3 text-white text-lg"
              placeholder="At least 6 characters"
            />
          </div>

          {error && (
            <div data-testid="register-error" className="text-sm text-[#F87171] border-l-2 border-[#F87171] pl-3">{error}</div>
          )}

          <button
            data-testid="register-submit-btn"
            disabled={loading}
            className="w-full bg-white text-[#0A0A0A] hover:bg-[#C5A059] hover:text-white transition-colors duration-300 px-8 py-4 text-xs uppercase tracking-[0.3em] disabled:opacity-50"
          >
            {loading ? "Creating account…" : "Create Account"}
          </button>
        </form>

        <p className="text-center text-sm text-[#A3A3A3] mt-8">
          Already a member?{" "}
          <Link to="/login" data-testid="register-to-login-link" className="text-white border-b border-[#C5A059] hover:text-[#C5A059] transition-colors">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
